import { render } from "./CreateDigitalProductModal.vue.js?vue&type=template&id=3ed60f19!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CreateDigitalProductModal.vue?vue&type=template&id=3ed60f19"
import script from "./CreateDigitalProductModal.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CreateDigitalProductModal.vue?vue&type=script&lang=js"
export * from "./CreateDigitalProductModal.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CreateDigitalProductModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/components/publication/CreateDigitalProductModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3ed60f19"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3ed60f19', __exports__)) {
    api.reload('3ed60f19', __exports__)
  }
  
  module.hot.accept("./CreateDigitalProductModal.vue.js?vue&type=template&id=3ed60f19!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CreateDigitalProductModal.vue?vue&type=template&id=3ed60f19", () => {
    api.rerender('3ed60f19', render)
  })

}


export default __exports__